module.exports = __webpack_public_path__ + "img/fig27.6f0b9b7d.jpg";